module.exports = __webpack_public_path__ + "assets/stuff-3.3ae34b92.svg";